import DefaultData from "../../CompanyData/DefaultData";

export default function B2CTopHeader(props) {
    return (
        <div className="topbar-image py-2 px-3 rounded-0 mb-0 alert fade show" style={{ backgroundColor: DefaultData.THEMECOLOR1 }}>
            <div className="d-flex justify-content-between align-items-center flex-wrap">
                {/* Left Side - Social Icons */}
                <div className="d-flex gap-2">
                    <a href={DefaultData?.FACEBOOKURL} target="_blank" rel="noopener noreferrer" className="text-white px-2">
                        <i className="ri-facebook-line me-2"></i>
                    </a>
                    <a href={DefaultData?.TWITTERURL} target="_blank" rel="noopener noreferrer" className="text-white px-2">
                        <i className="ri-twitter-line me-2"></i>
                    </a>
                    <a href={DefaultData?.INSTGRAMURL} target="_blank" rel="noopener noreferrer" className="text-white px-2">
                        <i className="ri-instagram-line me-2"></i>
                    </a>
                   
                </div>

                {/* Right Side - Contact Info */}
                <div className="d-flex gap-3 flex-wrap text-white">
                    <span className="px-2 mb-0 d-flex align-items-center">
                        <i className="ri-phone-line me-2"></i>
                        {props?.value?.companyPhoneNumber ?? DefaultData.DEFAULTCOMPANYPHONENUMBER}
                    </span>
                    <span className="px-2 mb-0 d-flex align-items-center">
                        <i className="ri-mail-line me-2"></i>
                        {props?.value?.companyEmail ?? DefaultData.DEFAULTCOMPANYEMAIL}
                    </span>
                </div>
            </div>
        </div>
    );
}